import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import PdpSharedDetailMeasurement from './helpers/PdpSharedDetailMeasurement';

// helpers
import get from 'lodash.get';

function PdpSharedDetailSeatHeight({ item }) {
    return (
        <PdpSharedDetailMeasurement
            dataTn="pdp-spec-seat-height"
            measurements={get(item, 'measurement.seatHeight')}
        />
    );
}

PdpSharedDetailSeatHeight.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailSeatHeight, {
    item: graphql`
        fragment PdpSharedDetailSeatHeight_item on Item {
            measurement {
                seatHeight: display(fields: [secondaryHeight]) {
                    ...PdpSharedDetailMeasurement_measurements
                }
            }
        }
    `,
});
